(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('JointStandController', JointStandController);

    JointStandController.$inject = ['$log', 'AreaService', '$rootScope', '$translate', 'CartFactory', '$state', 'AreaCalculationService', '$localStorage', '$sce'];

    function JointStandController($log, AreaService, $rootScope, $translate, CartFactory, $state, AreaCalculationService, $localStorage, $sce) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.labels = [];
        vm.priceTable = [];
        vm.sanitizedJointInfo2 = '';
        vm.area = null;

        // RESERVED!! USE THIS OBJECT TO POST DATA
        vm.jointStand = {
            cartPositionPrice: 0,
            cartPositionParent: null,
            cartPositionLabel: null,
            cartPositionType: 'Joint_Stand',
            cartPositionId: null
        };

        // FUNCITONS PUBLIC
        vm.pageLoaded = pageLoaded;
        vm.bookArea = bookArea;
        vm.showPrices = showPrices;
        vm.goBack = goBack;
        vm.trustHtml = trustHtml;

        function goBack() {
            $state.go('area');
        }

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.prices.prices);

        });

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                values.push(value);
            });
            array = values;
        }

        load();

        // FUNCTION DECLARATIONS
        function load() {
            AreaService.loadPrices('Joint_Stand').then(successPrices, error);
            AreaService.loadLabels('Joint_Stand').then(successLabels, error);
            AreaService.loadCartLabels('Joint_Stand').then(successCartLabels, error);
            loadArea();
        }

        function successPrices(response) {
            $log.debug("JointStandController | Fetching prices ", response.data);
            vm.prices = response.data;
            translateComboBoxValues(vm.prices.prices);
        }

        function successLabels(response) {
            $log.debug("JointStandController | Fetching labels ", response.data);
            angular.forEach(response.data, function (value) {
                vm.labels[value.key] = value.translations;
            });
        }

        function successCartLabels(response) {
            $log.debug('JointStandController | fetching area translation', response.data);
            vm.jointStand.cartPositionLabel = response.data;
        }

        function loadArea() {
            vm.area = $localStorage.areaInformation.areas.find(function (area) {
                return area.areaType === 'Joint_Stand';
            });
        }

        function error(response) {
            $log.debug('JointStandController | ERROR:', response);
        }

        function trustHtml(value) {
            return $sce.trustAsHtml(value);
        }

        function pageLoaded() {
            return true;
        }

        function bookArea() {
            $log.debug('JointStandController | Book Joint_Stand:', vm.jointStand);

            var item = {
                type: 'Area',
                areaType: 'Joint_Stand',
                cartPositionPrice: vm.jointStand.price.price,
                cartPositionParent: null,
                cartPositionLabel: vm.jointStand.cartPositionLabel,
                cartPositionId: null,
                price: vm.jointStand.price.id,
                fields: {
                    suggestions: vm.jointStand.suggestions,
                    weExhibit: vm.jointStand.vehicleDescription,
                    heaviestObject: vm.jointStand.heaviestObject,
                    maxWeightPerSq: vm.jointStand.maxWeightPerSq,
                    ownstand: vm.jointStand.ownstand,
                    requestedStandSystemOffer: vm.jointStand.requestedStandSystemOffer

                },
                id: null
            };

            $localStorage.showSuccessAlert = true;

            CartFactory.addItem(item);
            $state.go('area');
        }

        function showPrices() {
            vm.priceTable = [];
        }

        return vm;
    }
})();
